import { render, staticRenderFns } from "./DashViewAdminXh.vue?vue&type=template&id=66db4232&"
import script from "./DashViewAdminXh.vue?vue&type=script&lang=js&"
export * from "./DashViewAdminXh.vue?vue&type=script&lang=js&"
import style0 from "./DashViewAdminXh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports